import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMacintosh: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMacintosh"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V19H19V22H5V19H4V2ZM18.5 17.5V3.5H5.5V17.5H18.5ZM7 5H17V13H7V5ZM13 14.5H17V16H13V14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMacintosh;
